class ScEventBus {
  constructor (eventBus) {
    this.scEventBus = eventBus;
  }

  publishEvent (name, data) {
    this.scEventBus.publish(name, data);
  }
}

export default new ScEventBus(window.scEventBus);
